
// api calls related constants
export const skpApiSettings = 'gdeSettings'
export const skpApiSettingsDoc = 'skpApi'
export const oneilApiJWT = 'oneilApiJWT'
export const oneilApiAcntValidate = 'oneilApiAcntValidate'
export const skpApiEndpoints = 'endpoints'
export const skpApiHeaders = 'headers'
export const skpApiHeaderUserId = 'userId'
export const HTTP_GET = 'GET'
export const HTTP_POST = 'POST'
export const DEFAULT_CONTENT_TYPE = 'application/json'
export const AUTH_TOKEN_EXPIRED_CODE = 'WSG990'
export const REQUEST_ERROR_CODE = 'VALGAL'
export const INVALID_JWT_TOKEN = 'WSG44'
export const RETRY_LATER = 'Unable to validate. Please try again later'

// general constants
// This is imposed by firetore for the max entries using an in operator.
export const ARRAY_LIMIT = 10


// job and data entry related constants
export const jobCollection = 'gdeJobs'
export const jobBoxesCollection = 'gdeBoxes'
export const jobFilesCollection = 'gdeFiles'
export const jobOpenStatus = ['Pending', 'Assigned', 'In Process', 'Ready To Transmit', 'Transmitted']
export const jobCreated = 'Pending'
export const jobAssigned = 'Assigned'
export const jobStarted = 'In Process'
export const readyToTransmit = 'Ready To Transmit'
export const jobTransmitted = 'Transmitted'
export const boxDeStarted = 'Data Entry In Process'
export const exceptionBox = 'Exception'
export const boxReadyForVerify = 'Ready For Verification' 
export const boxVerificationStarted = 'Verification In Process'
export const boxReadyForQc = 'Ready For Quality Check'
export const boxQcStarted = 'Quality Check In Process'
export const boxReKeyRequired = 'Requires Rekey'
export const boxReadyForTransmit = 'Ready To Transmit'
export const boxTransmitted = 'Transmitted'
export const currentJobOpenLabel = 'All Open Jobs:'
export const currentJobAssignedLabel = 'Assigned:'
export const currentJobPendingLabel = 'Pending:' 
export const currentJobInProcessdLabel = 'In Process:'
export const currentJobReadyForVerifyLabel = 'Ready For Verification:'
export const currentJobReadyForQcLabel = 'Ready For Quality Check:'
export const currentJobTransmittedTodayLabel = 'Submitted Today:'
export const myJobLabel = 'My Job:'
export const myJobDataEntryLabel = 'Data Entry:'
export const myJobVerificationLabel = 'Verification:'
export const myJobUnAssignedLabel = 'UnAssigned Job:'
export const myJobSubmittedTodayLabel = 'Submitted Today:'
export const myJobTramsmittedLabel = 'Transmitted:'
export const deJobCategory = 'Data Entry User'
export const verifyJobCategory = 'verification'
export const OpenJobsBoxStatus = 
['Data Entry In Process',
  'Ready for Verification',
  'Verification in Process', 
  'Ready for Quality Check',
  'Quality Check in Process', 
  'Requires ReKey', 
  'Approved',
  'Transmitted']

export const jobReportCollection = 'gdeReports'
// metrics related constant
export const metricsCollectionName = 'gdeMetrics'
export const timeSheetsCollectionName = 'timesheets'
export const dataEntryUser = 'Data Entry User'
export const verificationUser = 'Verification User'

export const locationCollectionName = 'locations'

export const totalImagesAllowedToCapture = 10

export const dateFormat = 'YYYY-MM-DD'
export const totalNoOfBoxesForJob = parseInt(9999)
export const ignoreBarcodeScanCharacters = ['P', 'W', 'R', 'T']

// arrays to define countries which supports CPF & RUT field formats
export const countrySpecificFormats = ['CPF', 'RUT']
export const cpfRutConfiguration = [
  { index: 0, formatName: 'CPF', formatCode: 'CPF', formatLenght: '14', country: ['br'], format: 'XXX.XXX.XXX-XX' },
  { index: 1, formatName: 'RUT', formatCode: 'RUT', formatLenght: '12', country: ['cl'], format: 'XX.XXX.XXX-X' }
]

export const languageConfig = [
  { languageCode: 'en', languageName: 'English', languageLabel: 'English' },
  { languageCode: 'fr', languageName: 'French', languageLabel: 'Français' },
  { languageCode: 'de', languageName: 'German', languageLabel: 'Deutsch' },
  { languageCode: 'es', languageName: 'Spanish', languageLabel: 'Español' },
  { languageCode: 'hu', languageName: 'Hungarian', languageLabel: 'Magyar' },
  { languageCode: 'it', languageName: 'Italian', languageLabel: 'Italiano' },
  { languageCode: 'nl', languageName: 'Dutch', languageLabel: 'Nederlands' },
  { languageCode: 'pt', languageName: 'Portuguese', languageLabel: 'Português' },
  { languageCode: 'ro', languageName: 'Romanian', languageLabel: 'Română' },
  { languageCode: 'sk', languageName: 'Slovak', languageLabel: 'Slovenský' },
  { languageCode: 'cs', languageName: 'Czech', languageLabel: 'Čeština' },
  { languageCode: 'tr', languageName: 'Turkish', languageLabel: 'Türkçe' },
  { languageCode: 'ar', languageName: 'Arabic', languageLabel: 'عربي' }
]

export const originalBarcodeLogic = {
  PWT: {
    logic: {
      chars: 'PWT',
      limit: 0,
      operator: '>',
      trim: true
    }
  },
  R: {
    logic: {
      chars: 'R',
      limit: 11,
      operator: '>',
      trim: true
    }
  }
}

export const newBarcodeLogic = {
  PWRT: {
    logic: {
      chars: 'PWRT',
      limit: 0,
      operator: '>',
      trim: true
    }
  }
}